<div fxFlex fxLayout="column">
	<div fxFlex fxLayout="column" fxLayoutAlign="center center">
		<div class="qr-logo">
			<div class="qr">
				<img [src]="coupon.presigned_url" class="qr-img" />
				<img src="assets/images/mdc-logo-with-tagline.png" class="mdc-logo">
				<div class="qr-code">{{ coupon.code }}</div>
			</div>
		</div>
	</div>

	<button color="primary" mat-raised-button (click)="dialogRef.close(true)" class="close-btn">{{ 'LABEL_CLOSE' | translate}}</button>
</div>